<template>
  <div>
    <!--список предыдущих заказов-->
    <div v-if="loading" style="border: 1px solid #F0F0F0">
      <v-progress-circular
          :width="2"
          indeterminate
          style="color: forestgreen"
      ></v-progress-circular>
    </div>
    <div v-else>
      <!--Отображаем последние 15 элементов-->
      <div v-if="empty_prev_orders_block === ''" class="prev_block uk-grid tm-grid-xsmall tm-child-width-1-15">
        <div v-for="(order, index) of prev_orders_block" :key="index" class="prev_item_">
          <div class="tm-order-prev-img uk-flex uk-flex-middle uk-flex-center uk-transition-toggle uk-position-relative uk-text-center uk-text-small">
            <div  class="uk-position-relative">
              <img v-if="order.little_photo_before" :src="order.little_photo_before" alt="" v-on:error="setFallbackImage()">
              <img v-else-if="order.little_photo_after" :src="order.little_photo_after" alt="" v-on:error="setFallbackImage()">
              <img v-else src="/img/images.png" alt="">
            </div>
            <a href="#" @click="showOrder(order,'prevBlock',index)" class="uk-transition-fade uk-position-cover uk-overlay-primary uk-flex uk-flex-center uk-flex-middle">
              <md-icon class="md-size-2x tm-light">zoom_in</md-icon>
            </a>
          </div>
          <div v-if="order.like_by_client" class="tm-chat-box-mess likes tm-text-small uk-margin-small-top uk-text-center">
            <span class="likes-gold">{{ "★".repeat(order.like_by_client['value']) }}</span>
            <span class="likes-grey">{{ "★".repeat(5 - order.like_by_client['value']) }}</span>
          </div>
        </div>
      </div>
      <div v-else>{{ empty_prev_orders_block }}</div>

      <!--Отображаем следующие 15 элементов-->
      <h4 class="uk-margin"> {{ local_page_keys.label_next_orders }}:</h4>
      <div v-if="empty_next_orders_block === ''" class="prev_block uk-grid tm-grid-xsmall tm-child-width-1-15">
        <div v-for="(order,index) of next_orders_block" :key="index" class="prev_item_">
          <div class="tm-order-prev-img uk-flex uk-flex-middle uk-flex-center uk-transition-toggle uk-position-relative uk-text-center uk-text-small">
            <div  class="uk-position-relative">
              <img v-if="order.little_photo_before" :src="order.little_photo_before" alt="" v-on:error="setFallbackImage()">
              <img v-else-if="order.little_photo_after" :src="order.little_photo_after" alt="" v-on:error="setFallbackImage()">
              <img v-else src="/img/images.png" alt="">
            </div>
            <a href="#" @click="showOrder(order,'nextBlock',index)" class="uk-transition-fade uk-position-cover uk-overlay-primary uk-flex uk-flex-center uk-flex-middle">
              <md-icon class="md-size-2x tm-light">zoom_in</md-icon>
            </a>
          </div>
          <div v-if="order.like_by_client" class="tm-chat-box-mess likes tm-text-small uk-margin-small-top uk-text-center">
            <span class="likes-gold">{{ "★".repeat(order.like_by_client['value']) }}</span>
            <span class="likes-grey">{{ "★".repeat(5 - order.like_by_client['value']) }}</span>
          </div>
        </div>
      </div>
      <div v-else>{{ empty_next_orders_block }}</div>
    </div>

    <FunctionInfoDialog :name="info.name"
                        :text="info.text"
                        :video="info.video"
                        :show="showDialog"
                        :items="info.items"
                        :function_name = "info.function_name"
                        @hide="showDialog = false; showDialog7 = true"/>

    <!--диалоговое окно для предыдущих выполненных заказов-->
    <md-dialog
        class="tm-gal-dialog_ tm-check-dialog"
        :md-active.sync="showDialog7"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true">
      <div class="uk-padding uk-position-relative tm-modal-page">
        <a href="#" class="uk-position-top-right uk-position-z-index tm-dialog-close" @click="showDialog7 = false">
          <span class="material-icons">close</span>
        </a>
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <preloader :is-visible="loadingOrder"></preloader>
          <div class="uk-width-auto">
            <h4>{{ local_page_keys.table_header_order_number }}: {{ currenPrevOrderId }}</h4>
          </div>
        </div>
        <div class="uk-grid uk-flex-middle_ uk-flex-center 4">
          <!--левая часть-->
          <div class="uk-width-1-2">
            <photo-block-with-zoom
                :zoneVisible="zoneVisible"
                :zone_photo="zone_photo"
                :afterVisible="afterVisible"
                :isOutChat="isOutChat"
                :main_photo_after="modal_photo_after"
                :main_photo_before="modal_photo_before"
                :orderId="Number(currentOrderId)"
                :fullImageList="fullImageList"
            />
          </div>
          <!--правая часть-->
          <div class="uk-width-expand" v-if="faces">
            <!--список функций, сделанные в заказе-->
            <div class="uk-padding-small tm-background-muted">{{ local_page_keys.label_ordering_instructions }}:</div>
            <div>
              <!--список-->
              <div class="uk-grid tm-grid-divider uk-grid-collapse uk-child-width-1-1 tm-info-list uk-text-small" data-uk-grid>
                <!--общее-->
                <div v-for="(face, key) in faces" :key="key">
                  <div class="uk-padding-xsmall">
                    <div class="uk-grid uk-grid-xsmall uk-child-width-auto uk-flex-middle" data-uk-grid>
                      <div>
                        {{ local_page_keys.label_instructions_face }} {{ key }}:
                      </div>
                    </div>
                  </div>
                  <div class="uk-grid tm-grid-divider uk-grid-collapse uk-child-width-1-1" v-for="(orderFunction, name) in face" :key="key+name" data-uk-grid>
                    <!--элемент-->
                    <div class="">
                      <div>
                        <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle" data-uk-height-match="target: > div > div" data-uk-grid>
                          <!--1 - иконка-->
                          <div class="uk-width-auto">
                            <div class="uk-padding-xsmall uk-flex uk-flex-middle">
                              <div class="uk-width-1-1">
                                <img v-if="orderFunction.icon" class="tm-img-icon" :src="orderFunction.icon"
                                     width="30" height="30" alt="">
                                <img v-else class="tm-img-icon" src="/img/images.png" width="30" height="30" alt="">
                              </div>
                            </div>
                          </div>
                          <!--2 - статусы-->
                          <div class="uk-width-2-5" style="line-height: 1.2;">
                            <div class="uk-padding-xsmall uk-flex uk-flex-middle">
                              <div class="uk-width-1-1">
                                <div v-if="orderFunction.capacity" class="tm-status" :class="orderFunction.capacity_color ? orderFunction.capacity_color : 'tm-status-custom'">
                                  {{ orderFunction.capacity }}
                                </div>
                                <div v-if="!orderFunction.capacity && orderFunction.text">{{ orderFunction.text }}
                                  <span class="material-icons" style="cursor: pointer" v-if="orderFunction.text && orderFunction.text.length > 0"
                                        @click="openGoogleTranslate(orderFunction.text)">translate</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--3 - функция-->
                          <div class="uk-width-expand" style="line-height: 1.2;">
                            <div class="uk-padding-xsmall uk-flex uk-flex-middle">
                              <div class="uk-width-1-1">
                                <div v-if="orderFunction.RU">{{ orderFunction.RU }}</div>
                                <div v-else>{{ orderFunction.name }}</div>
                              </div>
                            </div>
                          </div>
                          <!--4 - инфо-->
                          <div class="uk-width-auto">
                            <div class="uk-padding-small uk-text-center uk-flex uk-flex-middle">
                              <div class="uk-width-1-1">
                                <a href="#" class="md-simple" @click="infoDialog(orderFunction)">
                                  <span class="material-icons">feedback</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div @mouseleave="isOutChat = true"  @mousemove="isOutChat = false">
                  <ChatBlock
                      :infoloading="infoloading"
                      v-if="order_chat !== '' && user"
                      :order_chat="!Array.isArray(order_chat) ? Object.values(order_chat) : order_chat"
                      :faces="faces"
                      :order_id="Number (this.currentOrderId)"
                      :user="user.email"
                      :role="user.role"
                      @zone-visible="zoneVisible = $event"
                      @after-visible="afterVisible = $event"
                      @zone_photo="zone_photo = $event"
                      @loading="infoloading = $event"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-position-center-left-out uk-padding"> {{activeOrderKey}}
        <a
            href="#" :disabled="activeOrderKey[currentType] && activeOrderKey[currentType] <= 0" @click="prevOrder"
            data-uk-tooltip="title: Предыдущий заказ; offset: 10"
            class="tm-light tm-light-hover uk-button uk-button-large uk-button-success"
            title="">
          <span class="material-icons">chevron_left</span>
        </a>
      </div>
      <div class="uk-position-center-right-out uk-padding">
        <a
            href="#" :disabled="activeOrderKey[currentType] && activeOrderKey[currentType] >= (activeOrders[currentType].length-1)" @click="nextOrder"
            data-uk-tooltip="title: Следующий заказ; offset: 10"
            class="tm-light tm-light-hover uk-button uk-button-large uk-button-success"
            title="">
          <span class="material-icons">chevron_right</span>
        </a>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import FunctionInfoDialog from "@/pages/Dashboard/Components/Dialogs/FunctionInfoDialog";
import LangMixin from "@/mixins/lang-mixin";
import ChatBlock from "@/pages/Dashboard/Components/ChatBlock";
import axios from "axios";
import PhotoBlockWithZoom from "@/pages/Dashboard/Components/PhotoBlockWithZoom";
import Preloader from "@/pages/Dashboard/Components/Preloader";

export default {
  name: "PrevOrdersBlockForAdmin",
  props: {
    currentOrderId: {
      type: Number,
      require: true
    },
    archive: {
      type: Boolean,
      default:false
    },
  },
  watch: {
    currentOrderId: function (newVal, oldVal) { // watch it
      if (newVal) {
        this.fetchPrevOrdersBlock();
      }
    }
  },
  mixins: [LangMixin],
  components: {FunctionInfoDialog,ChatBlock, PhotoBlockWithZoom, Preloader},
  data: () => ({
    infoloading:true,
    loading: true,
    loadingOrder: false,
    prev_orders_block: null,
    next_orders_block: null,
    currentType: null,
    showDialog7: false,
    showDialog: false,
    info: {
      name: '',
      text: '',
      video: '',
      items: {},
      function_name: ''
    },
    empty_prev_orders_block: '',
    empty_next_orders_block: '',
    modal_photo_after: null,
    modal_photo_before: null,
    role: '',
    faces: [],
    local_page_keys: {},
    baseUrl: '',
    order_chat: '',
    user: '',
    description: 'before',
    getterKey:0,
    currenPrevOrderId:null,
    fullImageList: {},
    zoneVisible: false,
    zone_photo: null,
    afterVisible: true,
    isOutChat: true,
    activeOrders: {},
    activeOrderKey: {},
  }),
  methods: {
    async fetchPrevOrdersBlock() {
      this.empty_prev_orders_block = '';
      this.empty_next_orders_block = '';
      try {
        await this.$store.dispatch("order/prevOrdersBlockById", {order_id:this.currentOrderId, archive:this.archive});
        let data = await this.$store.getters['order/prevOrdersBlockById'];
        if (data) {
          if (typeof (data.prev_orders_block) !== 'string') {
            this.prev_orders_block = data.prev_orders_block;
            this.loading = false;

          } else {
            this.empty_prev_orders_block = data.prev_orders_block;
            this.loading = false;
          }
          if (typeof (data.next_orders_block) !== 'string') {
            this.next_orders_block = data.next_orders_block;
            this.loading = false;
          } else {
            this.empty_next_orders_block = data.next_orders_block;
            this.loading = false;
          }
         // this.fullImageList = data.order_photo_file_list;

          if (this.prev_orders_block) {
            this.activeOrders['prevBlock'] = this.prev_orders_block.map((order) => order.order_id ?? null);
          }
          if (this.next_orders_block) {
            this.activeOrders['nextBlock'] = this.next_orders_block.map((order) => order.order_id ?? null);
          }

        } else {
          this.errors = 'Failed historyBlock';
          this.loading = false;
        }
      } catch (e) {
        alert(e);
      }
    },
    async showOrder(data,type,index) {
      this.loadingOrder = true;
      this.currentType = type;
      this.activeOrderKey[type] = index;
      this.faces = [];
      this.showDialog7 = true;
      this.modal_photo_after = data.modal_photo_after;
      this.modal_photo_before = data.modal_photo_before;
      this.fullImageList = data.order_photo_file_list;
      if (data.order_id) {
        this.currenPrevOrderId = data.order_id;
        this.fetchChatBlock();
        await this.$store.dispatch("order/orderFunctionsBlock", {'order_id': data.order_id});
        let result = this.$store.getters['order/orderFunctionsBlock'];
        this.faces = result && result.order_functions ? result.order_functions : [];
      }
      this.loadingOrder = false;
    },
     async nextOrder() {
      let index = this.activeOrderKey[this.currentType] + 1;
      if (this.activeOrders[this.currentType][index]) {
        let order = null;
        if (this.currentType === 'prevBlock') {
          order = this.prev_orders_block[index]
        } else if (this.currentType === 'nextBlock') {
          order = this.next_orders_block[index]
        }
        if (order)
          await this.showOrder(order,this.currentType,index);
      }
    },
     async prevOrder() {
      let index = this.activeOrderKey[this.currentType] - 1;
      if (this.activeOrders[this.currentType][index]) {
        let order = null;
        if (this.currentType === 'prevBlock') {
          order = this.prev_orders_block[index]
        } else if (this.currentType === 'nextBlock') {
          order = this.next_orders_block[index]
        }
        if (order)
          await this.showOrder(order,this.currentType,index);
      }
    },
    async fetchChatBlock() {
      try {
        this.order_chat = '';
        let data;
        await this.$store.dispatch("order/historyBlock", this.currenPrevOrderId);
        data = await this.$store.getters["order/historyBlock"];
        if (data.status === 'ok') {
          this.order_chat = data.chat !== '' ? JSON.parse(data.chat) : '';
        } else {
          this.errors = this.local_page_keys.alert_failed_historyBlock;
          this.loading = false;
        }
      } catch (e) {
        alert(e);
      }
    },
    async getPageLocalization() {
      this.local_page_keys = Object.assign({}, await this.$filtergetLocalisationPage('order-infoBlock'), await this.$filtergetLocalisationPage('admin_orders_history'));
    },

    infoDialog(faceValue) {
      this.info.name = faceValue.RU;
      this.info.function_name = faceValue.name;
      this.info.text = faceValue.instruction_text;
      this.info.video = faceValue.video;
      this.info.items = faceValue.links;
      this.showDialog7 = false;
      this.showDialog = true;
    },
    setDescription(type) {
      switch (type) {
        case "modal_photo_after":
          this.description = 'after';
          break;
        case "modal_photo_before":
          this.description = 'before';
          break;
        default:
          this.description = 'before';
          break;
      }
    },
    setFallbackImage() {
      event.target.src =  "/img/images.png";
    }
  },

  async created() {
    this.role = this.$store.getters['profile/role'];
    this.baseUrl = process.env.VUE_APP_API_BASE_URL.replace('api/v1', '');
    await this.fetchPrevOrdersBlock();
    await this.getPageLocalization();
    this.getterKey++;
    this.user = await this.$store.getters['profile/me'](this.getterKey);

  },
}
</script>

<style>
/*Layout*/
@import '../../../../assets/css/uikit/grid.css';
/*Utilities*/
@import '../../../../assets/css/uikit/width.css';
@import '../../../../assets/css/uikit/height.css';
@import '../../../../assets/css/uikit/flex.css';
@import '../../../../assets/css/uikit/margin.css';
@import '../../../../assets/css/uikit/padding.css';
@import '../../../../assets/css/uikit/position.css';
@import '../../../../assets/css/uikit/utility.css';
@import '../../../../assets/css/uikit/transition.css';
@import '../../../../assets/css/uikit/text.css';
@import '../../../../assets/css/uikit/overlay.css';
@import '../../../../assets/css/custom.css';

.prev_block {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.uk-transition-toggle {
  -webkit-tap-highlight-color: transparent;
}

.prev_item {
  margin: 0 5px;
}

.prev_modal {
  padding: 30px;
}

</style>